import { isEmpty } from '@sgme/fp';

export function parsePastedBoolean(text: string | boolean | undefined): boolean | undefined {
  if (typeof text === 'boolean') {
    return text;
  }

  if (isEmpty(text)) {
    return undefined;
  }
  return text === 'true';
}

export const YES_NO = { yes: true, no: false };
export type YesNo = keyof typeof YES_NO;
export const YES_NO_AVAILABLE_VALUES: YesNo[] = ['yes', 'no'] as const;

export function booleanToYesNo(bool: Nullable<boolean>): Nullable<YesNo> {
  switch (bool) {
    case true:
      return 'yes';
    case false:
      return 'no';
    default:
      return null;
  }
}
